import React, { ReactNode } from "react";

// Style
import {
  RadioContainer,
  Tab,
  TabContent,
  RadioWrapper,
  Radio as StyledRadio,
  Label,
} from "./styles";

type OnboardingRadioProps = {
  context: string;
  optionId: string;
  checked: boolean;
  label: string | ReactNode;
  changeSelectedOption: (optionId: string) => void;
  isFullWidth?: boolean;
  hasUniqueLabel?: boolean;
  uniqueLabel?: ReactNode | null;
};

export const Radio = ({
  context,
  optionId,
  checked,
  label,
  changeSelectedOption,
  isFullWidth = false,
  hasUniqueLabel = false,
  uniqueLabel,
}: OnboardingRadioProps) => (
  <RadioContainer
    className="radio-container"
    isFullWidth={isFullWidth}
    data-testid="onboarding-radio">
    <input
      id={optionId}
      type="radio"
      name={optionId}
      value={optionId}
      onChange={() => changeSelectedOption(optionId)}
    />
    <Tab
      htmlFor={optionId}
      onClick={() => changeSelectedOption(optionId)}
      checked={checked}>
      <RadioWrapper>
        <StyledRadio checked={checked} />
      </RadioWrapper>
      <TabContent>
        {hasUniqueLabel ? (
          uniqueLabel
        ) : (
          <Label checked={checked}>{label}</Label>
        )}
      </TabContent>
    </Tab>
  </RadioContainer>
);
